import { optionTitle_connected } from './ConnectedAccountsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const ConnectedAccountsOption: LazyOption = createLazyOption(
    {
        key: 'connected',
        titleStringKey: optionTitle_connected,
        searchTermsStringKey: optionTitle_connected,
        isHidden: () => !isFeatureEnabled('auth-connectedAccounts'),
        allowedOptionKeys: ['AttachmentConnectedAccounts', 'ConnectedAccounts'],
    },
    lazyFullModule,
    m => m.default
);
export default ConnectedAccountsOption;
